import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import toast from "react-hot-toast";

const AddOptionModal = ({ show, onClose, onAddOption }) => {
  const [newOptionValue, setNewOptionValue] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newOptionValue.trim() === "") {
      toast.error("Option value cannot be empty.");
      return;
    }
    const newOption = { label: newOptionValue, value: newOptionValue };
    onAddOption(newOption);
    setNewOptionValue("");
    onClose();
    toast.success("Option added successfully!");
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add New Option</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>New Option Value</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter new option"
              value={newOptionValue}
              onChange={(e) => setNewOptionValue(e.target.value)}
            />
          </Form.Group>
          <Button variant="primary" type="submit">
            Add Option
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddOptionModal;